import { TemplateLibrary } from "../common/TemplateLibrary/TemplateLibrary";

export const Dashboard = ({ currentRole }: { currentRole: any }) => {
  return <TemplateLibrary userRole={currentRole} />;
};
